/**
 * The one place that knows the shape of a combined invite URL.
 *
 * Two builders need it and they cannot share a function: the browser-facing one in
 * `index.ts` takes the mapped `Person` (with `invite_token`), while the scheduler's
 * takes the raw row shape from `types.ts` (with `profile_completion_token`). They
 * also resolve their base URL differently — `import.meta` in the browser,
 * `process.env` on Fly. So what is shared here is the path string, nothing else;
 * that is the part that must not drift.
 *
 * Deliberately a leaf module: no imports, no env access, so either side can pull it
 * in without dragging the other's runtime along.
 */

/**
 * Path (no origin) of the combined invite route — see `/invite/:personSlug/:showSlug`
 * in apps/admin/src/App.tsx.
 *
 * Slugs and tokens go in unencoded, matching what `generateInviteLink` and
 * `generateHappeningStubLink` already emit. Tokens come from `secureToken()` (hex)
 * and slugs are already slugified, so there is nothing here that needs escaping;
 * encoding would only make previously-issued links stop matching.
 */
export const buildCombinedInvitePath = (
    personSlug: string,
    showSlug: string,
    inviteToken: string,
    stubToken: string,
): string => `/invite/${personSlug}/${showSlug}?invite=${inviteToken}&stub=${stubToken}`;
